import { ChangeDetectionStrategy, Component, input, OnInit, output, signal } from '@angular/core';

import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { InputText } from 'primeng/inputtext';
import { InputMask } from 'primeng/inputmask';
import { Button } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { CardContent } from '@/shared/components/card-content/card-content';
import { DialogModule } from 'primeng/dialog';
import { VisualizadorPdf } from '@/shared/components/visualizador-pdf/visualizador-pdf';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
@Component({
    selector: 'app-formacao-pos',
    standalone: true,
    imports: [DialogoPadraoDirective, ReactiveFormsModule, Select, InputText, InputMask, Button, Tooltip, CardContent, DialogModule, VisualizadorPdf],
    templateUrl: './formacao-pos.component.html',
    styleUrl: './formacao-pos.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
/** Formulário de pós-graduação (usado no diálogo de registro de formação). */
export class FormacaoPosComponent implements OnInit {
    form = input.required<FormGroup>();
    modoEdicao = input<boolean>(false);
    posDenominacaoOptions = input<Array<{ label: string; value: number }>>([]);
    posDenominacoesCarregando = input<boolean>(false);
    comprovanteGraduacaoOptions = input<Array<{ label: string; value: number }>>([]);

    pesquisarEscola = output<void>();
    openDenominacaoSelect = output<void>();
    abrirEspecialidades = output<void>();

    exibirDialogAnexo = signal(false);
    blobAnexo = signal<Blob | null>(null);
    nomeArquivoAnexo = 'documento-pos-graduacao.pdf';

    ngOnInit(): void {}

    async abrirDocumentoPos(): Promise<void> {
        const url = String(this.form().get('posUrlDocumento')?.value ?? '').trim();
        if (!url) return;

        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`Falha HTTP: ${response.status}`);

            const blob = await response.blob();
            if ((blob.type || '').includes('pdf') || !blob.type) {
                this.blobAnexo.set(blob.type ? blob : new Blob([blob], { type: 'application/pdf' }));
                this.exibirDialogAnexo.set(true);
                return;
            }
        } catch {
            // fallback abaixo
        }

        window.open(url, '_blank', 'noopener,noreferrer');
    }

    fecharDialogAnexo(): void {
        this.exibirDialogAnexo.set(false);
        this.blobAnexo.set(null);
    }

    campoInvalido(nomeCampo: string): boolean {
        const campo = this.form().get(nomeCampo);
        return !!campo && campo.invalid && (campo.touched || campo.dirty);
    }

    mensagemErroCampo(nomeCampo: string): string | null {
        const campo = this.form().get(nomeCampo);
        if (!campo?.errors) return null;

        if (campo.errors['required']) return 'Campo obrigatório.';
        if (campo.errors['dataMaiorQueHojeInvalida']) return 'A data deve ser menor ou igual a hoje.';
        return 'Valor inválido.';
    }
}
